import https from "./https"
import store from "@/store"

const invoice = {
    getInvoices(params) {
      const organization = store.state.general.organization
      return https.get('admin/organizations/' + organization.id + '/invoices', {params})
    },

    getInvoice(id) {
      const organization = store.state.general.organization
      return https.get('admin/organizations/' + organization.id + '/invoices/' + id)
    },

    // 發票創建
    createInvoice(params) {
      const organization = store.state.general.organization
      return https.post(`admin/organizations/${organization.id}/invoices`, params);
    },

    // 發票創建並開立
    createAndIssueInvoice(params) {
      const organization = store.state.general.organization
      return https.post(`admin/organizations/${organization.id}/invoices/issue`, params);
    },

    // 開立發票
    issueInvoice(invoiceId) {
      const organization = store.state.general.organization
      return https.post(`admin/organizations/${organization.id}/invoices/${invoiceId}/issue`);
    },

    // 作廢發票
    cancelInvoice(invoiceId) {
      const organization = store.state.general.organization
      return https.post(`admin/organizations/${organization.id}/invoices/${invoiceId}/cancel`);
    },

    updateInvoice(id, params) {
      const organization = store.state.general.organization
      return https.put(`admin/organizations/${organization.id}/invoices/${id}`, params);
    },

    deleteInvoice(id) {
      const organization = store.state.general.organization
      return https.delete(`admin/organizations/${organization.id}/invoices/${id}`);
    },
  }
  
  export default invoice